export interface FontOption { id: string; name: string; category: 'Sans' | 'Serif' | 'Display' | 'Mono' | 'Script'; weights: string }

export const fontOptions: FontOption[] = [
  { id: 'figtree', name: 'Figtree', category: 'Sans', weights: '400;500;600;700;800' },
  { id: 'inter', name: 'Inter', category: 'Sans', weights: '400;500;600;700;800' },
  { id: 'manrope', name: 'Manrope', category: 'Sans', weights: '400;500;600;700;800' },
  { id: 'outfit', name: 'Outfit', category: 'Sans', weights: '400;500;600;700;800' },
  { id: 'poppins', name: 'Poppins', category: 'Sans', weights: '400;500;600;700' },
  { id: 'sora', name: 'Sora', category: 'Sans', weights: '400;500;600;700;800' },
  { id: 'space-grotesk', name: 'Space Grotesk', category: 'Sans', weights: '400;500;600;700' },
  { id: 'jakarta', name: 'Plus Jakarta Sans', category: 'Sans', weights: '400;500;600;700;800' },
  { id: 'playfair', name: 'Playfair Display', category: 'Serif', weights: '400;500;600;700;800' },
  { id: 'dm-serif', name: 'DM Serif Display', category: 'Serif', weights: '400' },
  { id: 'lora', name: 'Lora', category: 'Serif', weights: '400;500;600;700' },
  { id: 'libre', name: 'Libre Baskerville', category: 'Serif', weights: '400;700' },
  { id: 'source-serif', name: 'Source Serif 4', category: 'Serif', weights: '400;500;600;700' },
  { id: 'merriweather', name: 'Merriweather', category: 'Serif', weights: '400;700' },
  { id: 'bebas', name: 'Bebas Neue', category: 'Display', weights: '400' },
  { id: 'anton', name: 'Anton', category: 'Display', weights: '400' },
  { id: 'archivo-black', name: 'Archivo Black', category: 'Display', weights: '400' },
  { id: 'unbounded', name: 'Unbounded', category: 'Display', weights: '400;600;800' },
  { id: 'syne', name: 'Syne', category: 'Display', weights: '400;600;700;800' },
  { id: 'jetbrains', name: 'JetBrains Mono', category: 'Mono', weights: '400;500;700' },
  { id: 'plex-mono', name: 'IBM Plex Mono', category: 'Mono', weights: '400;500;700' },
  { id: 'caveat', name: 'Caveat', category: 'Script', weights: '400;600;700' },
  { id: 'dancing', name: 'Dancing Script', category: 'Script', weights: '400;600;700' },
]

const byId = new Map(fontOptions.map((font) => [font.id, font]))
export function fontById(id: string): FontOption | undefined { return byId.get(id) }

export const defaultFontStack = 'Manrope, "Segoe UI", system-ui, sans-serif'
export function fontFamilyStack(id: string): string {
  const font = byId.get(id)
  if (!font) return defaultFontStack
  const fallback = font.category === 'Serif' ? 'serif' : font.category === 'Mono' ? 'monospace' : font.category === 'Script' ? 'cursive' : 'sans-serif'
  return `"${font.name}", ${fallback}`
}
